"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonschema_1 = require("../../utils/jsonschema");
var schema = {
    $id: jsonschema_1.$id('booleanExpression'),
    title: 'Boolean expression',
    anyOf: [
        { type: 'boolean' },
        { $ref: jsonschema_1.$id('orExpression') },
        { $ref: jsonschema_1.$id('andExpression') },
        { $ref: jsonschema_1.$id('notExpression') },
        { $ref: jsonschema_1.$id('equalExpression') },
        { $ref: jsonschema_1.$id('sortedExpression') },
        { $ref: jsonschema_1.$id('untypedResolvedExpression') }
    ]
};
exports.default = schema;
//# sourceMappingURL=boolean.schema.js.map